import React, { useContext } from 'react';
import PropTypes from 'prop-types';

import SubNavigation from "./SubNavigation";
import AuthorizedUser from "../utils/AuthorizedUser";
import AuthorizedUserContext from "../utils/AuthorizedUserContext";

function SourcesTabs(props) {
	const authenticatedUser = useContext(AuthorizedUserContext);
	const tabs = [{
		label: "Gsuite",
		value: "gsuite",
		hasAccess: true
	},
	// {
	// 	label: "Facebook",
	// 	value: "facebook",
	// 	hasAccess: true
	// },{
	// 	label: "Instagram",
	// 	value: "instagram",
	// 	hasAccess: true
	// },{
	// 	label: "Exchange",
	// 	value: "Exchange",
	// 	hasAccess: true
	// }
];

	let {tabClicked, selectedTab, setBannerClassName, hasNudgeBanner} = props;

	return (
		<SubNavigation
			tabs={tabs}
			title="Settings"	
            isEdit={false}		
			selectedTab={selectedTab}
			tabClicked={tabClicked}
			hasNudgeBanner={hasNudgeBanner}
			setBannerClassName={setBannerClassName} />
	);
}

SourcesTabs.propTypes = {
	hasNudgeBanner: PropTypes.bool,
	tabClicked: PropTypes.func.isRequired,
	setBannerClassName: PropTypes.func.isRequired,
	selectedTab: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]).isRequired,	
};

export default SourcesTabs;